import { createSlice } from "@reduxjs/toolkit";
import { overviewTemplateActions } from "./overviewTemplate.actions";


interface OverviewTemplateState {
    loading: boolean;
    success: any;
    error: any;
    TemplateDetails: any;
    tabs: Array<{id: string, label: string}>;
    selectedTab: string | null;
    selectedRoles: any;
    projectTasks: any;
    specificTaskDetails: any;
    possiblePredecessors: any;
}

const initialState: OverviewTemplateState = {
    loading: false,
    success: null,
    error: null,
    TemplateDetails: null,
    tabs: [],
    selectedTab: null,
    selectedRoles: null,
    projectTasks: null,
    specificTaskDetails: null,
    possiblePredecessors: null,
}

const overviewTemplateSlice = createSlice({
    name: 'overviewTemplate',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        // --------------------- cases of get project overview details api data -------------------------
        .addCase(overviewTemplateActions.getProjectOverviewTemplateAction.pending, (state) => {
            state.loading = true;
        })
        .addCase(overviewTemplateActions.getProjectOverviewTemplateAction.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload;
            state.TemplateDetails = action.payload.data;
            
            // Set tabs and project tasks from response
            if (action.payload.data?.data) {
                state.tabs = action.payload.data.data.tabs || [];
                state.projectTasks = action.payload.data.data.tasks || null;
                state.selectedRoles = action.payload.data.data.roles || null;
                // Set first tab as default if no tab is selected
                if (!state.selectedTab && state.tabs.length > 0) {
                    state.selectedTab = state.tabs[0].id;
                }
            }
            
            // Update selectedTab based on the current request
            if (action.meta?.arg?.tab) {
                state.selectedTab = action.meta.arg.tab;
            }
        })
        .addCase(overviewTemplateActions.getProjectOverviewTemplateAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        
        // --------------------- cases of get specific task details api data -------------------------
        .addCase(overviewTemplateActions.getSpecificTaskDetailsAction.pending, (state) => {
            state.loading = true;
        })
        .addCase(overviewTemplateActions.getSpecificTaskDetailsAction.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload;
            state.specificTaskDetails = action.payload.data;
        })
        .addCase(overviewTemplateActions.getSpecificTaskDetailsAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        // --------------------- cases of get possible predecessors api data -------------------------
        .addCase(overviewTemplateActions.getPossiblePredecessorsAction.pending, (state) => {
            state.loading = true;
        })
        .addCase(overviewTemplateActions.getPossiblePredecessorsAction.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload;
            state.possiblePredecessors = action.payload.data;
        })
        .addCase(overviewTemplateActions.getPossiblePredecessorsAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
    }
})


export default overviewTemplateSlice.reducer;